<template>
    <div class="home-quote-step select-coverage">
        <quote-step-header
            :title="subStepFields.title"
            :key="subStepFields.title"
            :subtitle="subStepFields.subtitle"
        ></quote-step-header>

        <form class="quote-form" @submit.prevent="next">
            <div class="form-row center mt-8 mb-16">
                <app-text-radio-buttons
                    v-model="form[stepName].coverage"
                    :items="homeCoverage"
                    :break-mobile="true"
                >
                </app-text-radio-buttons>
            </div>
            <div>
                <transition name="slide-fade">
                    <div
                        class="mb-16"
                        v-if="coverage === constants.BUILDING_HOME"
                    >
                        <div class="floors">
                            <div>
                                <app-input
                                    type="number"
                                    :label="trans('types.floors.what_floor')"
                                    v-model="form[stepName].floors.level"
                                />
                                <ul class="mt-2 mr-4">
                                    <li>
                                        {{ trans("types.floors.floor_ground") }}
                                    </li>
                                </ul>
                            </div>
                            <app-input
                                type="number"
                                :label="trans('types.floors.how_manny_floors')"
                                v-model="form[stepName].floors.amount"
                            />
                        </div>
                    </div>
                </transition>
                <div v-if="!!filledCoverage">
                    <app-input
                        type="number"
                        :label="trans('types.property.area')"
                        v-model="form[stepName].property.area"
                        class="mb-16"
                    />
                    <app-label>{{ trans("types.property.how_old") }}</app-label>
                    <app-text-radio-buttons
                        class="mb-16"
                        v-model="form[stepName].property.age"
                        :items="propertyAge"
                        :break-mobile="true"
                    ></app-text-radio-buttons>
                </div>
            </div>
            <div class="submit-row">
                <app-button :disabled="disabledConditions" :loading="loading">
                    {{ "quote.welcome.next" | __ }}
                </app-button>
            </div>
        </form>
    </div>
</template>

<script>
import QuoteStep from "../../../mixins/QuoteStep";
import AppInput from "../../Forms/Input.vue";
import AppLabel from "../../Forms/Label.vue";

export default {
    name: "HomeQuoteSelectCoverage",
    components: { AppInput, AppLabel },
    mixins: [QuoteStep],

    props: {},

    data() {
        return {
            subSteps: ["default"]
        };
    },

    computed: {
        homeCoverage() {
            return [
                {
                    label: this.trans("types.building_home"),
                    value: this.constants.BUILDING_HOME,
                    icon: "apartment-small",
                    icon_checked: "apartment-checked"
                },
                {
                    label: this.trans("types.private_home"),
                    value: this.constants.PRIVATE_HOME,
                    icon: "house-small",
                    icon_checked: "house-small-checked"
                }
            ];
        },
        filledCoverage() {
            return [
                this.constants.PRIVATE_HOME,
                this.constants.BUILDING_HOME
            ].includes(this.coverage);
        },
        insuranceType() {
            return this.form["HomeQuoteSelectDate"].insuranceType;
        },
        coverage() {
            return this.stepFormFields.coverage;
        },
        propertyAge() {
            return [
                {
                    label: this.trans("types.property.new"),
                    value: this.constants.HOME_NEW
                },
                {
                    label: this.trans("types.property.over_five_years"),
                    value: this.constants.HOME_ABOVE_5
                },
                {
                    label: this.trans("types.property.over_twenty_years"),
                    value: this.constants.HOME_ABOVE_20
                }
            ];
        },
        canMoveNext() {
            if (
                !this.coverage ||
                this.stepFormFields.property.age === "" ||
                !this.stepFormFields.property.area
            ) {
                return false;
            }

            if (this.coverage === this.constants.PRIVATE_HOME) {
                return true;
            }

            if (
                !this.stepFormFields.floors.amount ||
                !this.stepFormFields.floors.level
            ) {
                return false;
            }

            return true;
        }
    }
};
</script>

<style lang="scss" scoped>
.home-quote-step {
    .quote-form {
        max-width: $mobile;
        height: auto;
        margin: 0 auto;
    }
}

.floors {
    display: flex;
    gap: 40px;

    @media (max-width: $tablet) {
        flex-direction: column;
    }

    > div {
        flex: 1;
    }
}

ul {
    list-style: disc;
}
</style>
